/** Etiquetas de albaran, plurales y saludos (es-ES). */

import { horaMadrid } from "@/lib/fechas";

const DASH = "\u2014";
const SERIE_VACIA = new Set(["", "00", "-", "\u2013", "\u2014"]);

export function fmtAlbaranNro(serie, numero) {
  const num = String(numero ?? "").trim();
  const ser = String(serie ?? "").trim();
  if (ser && !SERIE_VACIA.has(ser)) return num ? `${ser}-${num}` : ser;
  return num || DASH;
}

export function palabraEnvio(n) {
  return Number(n) === 1 ? "env" + String.fromCharCode(0xed) + "o" : "env" + String.fromCharCode(0xed) + "os";
}

export function fmtNumeroDeca(d) {
  const n = d?.numero_deca || d?.numeroDeca;
  if (n) return String(n);
  const id = d?.id || d?.deca_id || "";
  return id ? String(id).slice(0, 8) : DASH;
}

export function fmtEnvios(n) {
  const k = Number(n) || 0;
  return `${k} ${palabraEnvio(k)}`;
}

export function saludo(nombre) {
  const h = horaMadrid();
  const i = String.fromCharCode(0xed);
  let base = "Buenos d" + i + "as";
  if (h >= 21 || h < 6) base = "Buenas noches";
  else if (h >= 14) base = "Buenas tardes";
  const quien = String(nombre || "").trim();
  return quien ? `${base}, ${quien}` : base;
}
